import { render, staticRenderFns } from "./FluxCD.vue?vue&type=template&id=2caf630e&scoped=true"
import script from "./FluxCD.vue?vue&type=script&lang=js"
export * from "./FluxCD.vue?vue&type=script&lang=js"
import style0 from "./FluxCD.vue?vue&type=style&index=0&id=2caf630e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2caf630e",
  null
  
)

export default component.exports